import { CheckListBarData, Modules, Stages, Steps } from "../../contracts";
import { Guide } from "../../hooks/interfaces";
import {
	OnboardingStateActions,
	OnboardingStateActionTypes
} from "../actions";
import { Client, Template } from "@/Contracts";
import { Reducer } from "redux";

export interface CurrentGuideProgress {
	activeModule: Modules | null;
	activeStage: Stages | null;
	activeStep: Steps | null;
}

export interface OnboardingMaps {
	stageSteps: Record<Stages, Guide[]>;
	moduleStages: Record<Modules, Stages[]>;
}

export interface OnboardingState {
	readonly currentGuideProgress: CurrentGuideProgress;
	readonly checkListBarData: CheckListBarData | null;
	readonly moduleOrder: Modules[];
	readonly clientDetail: Client | null;
	readonly documentTemplate: Template | null;
	readonly onboardingMaps: OnboardingMaps | null;
	readonly isProgressInitialized: boolean;
}

export const initialState: OnboardingState = {
	currentGuideProgress: {
		activeModule: null,
		activeStage: null,
		activeStep: null
	},
	checkListBarData: null,
	moduleOrder: [],
	clientDetail: null,
	documentTemplate: null,
	onboardingMaps: null,
	isProgressInitialized: false
};

const OnboardingStateReducer: Reducer<
	OnboardingState,
	OnboardingStateActions
> = (
	state: OnboardingState = initialState,
	action: OnboardingStateActions
): OnboardingState => {
	switch (action.type) {
		case OnboardingStateActionTypes.UPDATE_CURRENT_GUIDE_PROGRESS: {
			return {
				...state,
				currentGuideProgress: action.currentGuideProgress
			};
		}
		case OnboardingStateActionTypes.UPDATE_PROGRESS_INITIALIZATION: {
			return {
				...state,
				isProgressInitialized: action.isProgressInitialized
			};
		}
		case OnboardingStateActionTypes.UPDATE_MODULE_ORDER: {
			return {
				...state,
				moduleOrder: action.moduleOrder
			};
		}
		case OnboardingStateActionTypes.UPDATE_ONBOARDING_MAPS: {
			return {
				...state,
				onboardingMaps: action.onboardingMaps
			};
		}
		case OnboardingStateActionTypes.CHECKLIST_BAR_DATA_SUCCESSFUL: {
			return {
				...state,
				checkListBarData: action.checkListBarData
			};
		}
		case OnboardingStateActionTypes.DUMMY_CLIENT_DATA_SUCCESSFUL: {
			return {
				...state,
				clientDetail: action.clientDetail
			};
		}

		case OnboardingStateActionTypes.DOCUMENT_TEMPLATE_DATA_SUCCESSFUL: {
			return {
				...state,
				documentTemplate: action.documentTemplate
			};
		}
		default: {
			return state;
		}
	}
};
export default OnboardingStateReducer;
